<script setup lang="ts"></script>

<template>
  <NuxtLinkLocale
    to="https://www.instagram.com/banks.kg/?hl=en"
    target="_blank"
    class="relative block overflow-hidden rounded-lg bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737] p-4 text-white transition-all duration-500 ease-out hover:from-[#A855F7] hover:via-[#EC4899] hover:to-[#FB923C]"
  >
    <!-- Desktop background -->
    <NuxtImg
      src="/images-backup/about/phone_bg.png"
      alt="Background"
      class="absolute bottom-0 right-0 hidden object-contain transition-opacity duration-300 sm:block"
      width="150"
      height="150"
      format="avif,webp"
      quality="85"
      loading="lazy"
    />
    <!-- Mobile background -->
    <NuxtImg
      src="/images-backup/about/phone_mobile_bg.png"
      alt="Background Mobile"
      class="absolute bottom-0 right-0 z-0 object-contain transition-opacity duration-300 sm:hidden"
      width="290"
      height="137"
      format="avif,webp"
      quality="85"
      loading="lazy"
    />
    <div class="relative z-10">
      <!-- Logo And Nickname (For Mobile) -->
      <div class="mb-3 flex items-center justify-between sm:hidden">
        <NuxtImg src="/images-backup/logos/logo-white.png" alt="Logo" width="70" height="26" />
        <div class="flex items-center gap-2.5">
          <div class="flex h-5 w-5 items-center justify-center rounded-full bg-white">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="url(#instagram-gradient)"
              xmlns="http://www.w3.org/2000/svg"
              class="size-3"
            >
              <defs>
                <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style="stop-color: #833ab4; stop-opacity: 1" />
                  <stop offset="50%" style="stop-color: #e1306c; stop-opacity: 1" />
                  <stop offset="100%" style="stop-color: #f77737; stop-opacity: 1" />
                </linearGradient>
              </defs>
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
              />
            </svg>
          </div>
          <span class="text-sm font-bold">@banks.kg</span>
        </div>
      </div>

      <!-- Logo (For Desktop) -->
      <NuxtImg
        src="/images-backup/logos/logo-white.png"
        alt="Logo"
        class="mb-3 hidden sm:block"
        width="86"
        height="32"
      />

      <h3
        class="z-10 max-w-40 text-base font-bold leading-tight sm:mb-6 sm:max-w-full sm:text-xl xl:max-w-52"
      >
        {{ $t('widget.instagram.title') }}
      </h3>

      <!-- Nickname (For Desktop) -->
      <div class="mb-4 hidden items-center gap-2.5 sm:flex">
        <div class="flex h-5 w-5 items-center justify-center rounded-full bg-white">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="url(#instagram-gradient-desktop)"
            xmlns="http://www.w3.org/2000/svg"
            class="size-3"
          >
            <defs>
              <linearGradient id="instagram-gradient-desktop" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color: #833ab4; stop-opacity: 1" />
                <stop offset="50%" style="stop-color: #e1306c; stop-opacity: 1" />
                <stop offset="100%" style="stop-color: #f77737; stop-opacity: 1" />
              </linearGradient>
            </defs>
            <path
              d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
            />
          </svg>
        </div>
        <span class="text-sm font-bold">@banks.kg</span>
      </div>
    </div>
  </NuxtLinkLocale>
</template>
